import { ConfigTabNav, type ConfigTabItem } from '@/components/layout/ConfigTabNav';

const tabs: ConfigTabItem[] = [
  {
    value: 'departments',
    labelKey: 'organization.tabs.departments',
    to: '/$slug/organization/departments'
  },
  {
    value: 'functions',
    labelKey: 'organization.tabs.functions',
    to: '/$slug/organization/functions'
  },
  {
    value: 'teams',
    labelKey: 'organization.tabs.teams',
    to: '/$slug/organization/teams'
  },
  {
    value: 'members',
    labelKey: 'organization.tabs.members',
    to: '/$slug/organization/org-members'
  },
  {
    value: 'systems',
    labelKey: 'organization.tabs.systems',
    to: '/$slug/organization/systems'
  },
  {
    value: 'external-contacts',
    labelKey: 'organization.tabs.externalContacts',
    to: '/$slug/organization/external-contacts'
  },
  {
    value: 'artifacts',
    labelKey: 'organization.tabs.artifacts',
    to: '/$slug/organization/artifacts'
  }
];

export function OrganizationTabsNav() {
  return <ConfigTabNav tabs={tabs} />;
}
